import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Wifi(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.851 15.999a1.696 1.696 0 110 3.391 1.696 1.696 0 010-3.391zm0-4a5.703 5.703 0 014.986 2.944 1 1 0 11-1.75.969A3.701 3.701 0 0011.85 14a3.7 3.7 0 00-3.25 1.938.999.999 0 11-1.756-.958A5.702 5.702 0 0111.85 12zm0-4a9.747 9.747 0 017.806 3.949 1.002 1.002 0 01-.211 1.399 1.002 1.002 0 01-1.4-.211A7.734 7.734 0 0011.852 10a7.732 7.732 0 00-6.197 3.139 1 1 0 01-1.61-1.188A9.746 9.746 0 0111.85 8zm0-3.999c4.097 0 7.948 1.818 10.565 4.988a1 1 0 01-1.542 1.273A11.669 11.669 0 0011.852 6a11.66 11.66 0 00-9.076 4.326.996.996 0 01-1.407.144.999.999 0 01-.144-1.406A13.648 13.648 0 0111.852 4z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoWifi = React.memo(Wifi);
export default MemoWifi;